export var GraphqlMiddlewareTemplate = /* @__PURE__ */ ((GraphqlMiddlewareTemplate2) => {
  GraphqlMiddlewareTemplate2["OperationTypes"] = "graphql-operations.d.ts";
  GraphqlMiddlewareTemplate2["ComposableContext"] = "nuxt-graphql-middleware/generated-types.d.ts";
  GraphqlMiddlewareTemplate2["Documents"] = "graphql-documents.mjs";
  return GraphqlMiddlewareTemplate2;
})(GraphqlMiddlewareTemplate || {});
export var GraphqlMiddlewareOperation = /* @__PURE__ */ ((GraphqlMiddlewareOperation2) => {
  GraphqlMiddlewareOperation2["Query"] = "query";
  GraphqlMiddlewareOperation2["Mutation"] = "mutation";
  return GraphqlMiddlewareOperation2;
})(GraphqlMiddlewareOperation || {});
export const CLIENT_CONTEXT_PREFIX = "__gqlc_";
